/**
 * @ngdoc directive
 * @name flowTimelineFile
 * @module flowingly.runner.directives
 * @description Directive for displaying the readonly details for a file previously uploaded.
 * https://bizflo.atlassian.net/wiki/display/TECH/Notes+On+File+Upload
 * @usage
 * ```
 *   <timeline-file filemeta="file" ng-repeat="file in $ctrl.files">
 * ```
 */
'use strict';
import angular from 'angular';
import FlowTimelineFileBridge from './FlowTimelineFileBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowTimelineFile', FlowTimelineFileBridge);
